// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	// Main Nav Dropdown
	const navItems = document.querySelectorAll('#primary-nav li');
	navItems.forEach(function (item) {
		item.addEventListener('mouseover', function () {
			item.classList.add('hover');
			let submenu = item.querySelector('ul.submenu');
			if (submenu) {
				submenu.classList.add('open');
			}
		});

		item.addEventListener('mouseout', function () {
			item.classList.remove('hover');
			let submenu = item.querySelector('ul.submenu');
			if (submenu) {
				submenu.classList.remove('open');
			}
		});
	});

	//Nav parent active primary menu desktop
	let item = document.querySelector('.privary-navigation__submenu .active');
	if (item != undefined) {
		let itemSubmenu = item.parentElement.parentElement.parentElement.firstElementChild;
		itemSubmenu.classList.add("active");
	}

	//dropdown for mobile
	document.querySelectorAll('#mobile-nav-js > li > a').forEach(link => {
		link.addEventListener('click', e => {
			if (link.nextSibling.nextSibling != null) {
				document.querySelectorAll('#mobile-nav-js > li').forEach(item => {
					if (link.parentNode !== item) item.classList.remove('submenu-show');
				});
				//remove this comment if you want show subnav for mobile
				e.preventDefault();
				link.parentNode.classList.toggle('submenu-show');
			}
		});
	});

	if (window.innerWidth <= 640) {
		document.querySelectorAll('input[type=date], input[type=time]').forEach((inputField) => {
				inputField.addEventListener('input', () => {
					if (inputField.value.length > 0) {
						inputField.classList.add('full')
					} else {
						inputField.classList.remove('full')
					}
				})
			})
	}

	if(document.querySelectorAll('.scroll-down').length > 0){
		document.querySelectorAll('.scroll-down').forEach(element =>{
			element.addEventListener('click', function(e){
				e.preventDefault()
				animateTo(`${e.target.href.split("#")[1]}`);
			});
		})
	}

}());

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
		if (document.querySelector('.sitemap') || document.querySelector('.terms-and-conditions ') || document.querySelector('#attractions')|| document.querySelector('.photos') || document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.add('up');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

}

//animation of scroll vanilla JS
function animateTo(target) {
	var gotoTarget = offset(document.getElementById(target)).top - 100;
	var from = window.pageYOffset
	var to = gotoTarget
	var duration = 1500;
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function () {
		var time = new Date().getTime() - start

		if (from <= to) {
			var yH = easeInOutQuart(time, from, to - from, duration)
		} else {

			var yH = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, yH)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}

//window offset
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return {
		top: rect.top + scrollTop,
		left: rect.left + scrollLeft
	}
}
